/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

export type BTAdminBuilderPreference =
  (typeof BTAdminBuilderPreference)[keyof typeof BTAdminBuilderPreference];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BTAdminBuilderPreference = {
  notificationHistoryRedesign: "notificationHistoryRedesign",
  taskManagementOptIn: "taskManagementOptIn",
  progressInvoicesEstimateGroups: "progressInvoicesEstimateGroups",
  selectionOptionDocumentScraping: "selectionOptionDocumentScraping",
  useBtAiForOcr: "useBtAiForOcr",
  costInboxProcessReceiptsInEmailBody: "costInboxProcessReceiptsInEmailBody",
  rNStandaloneFilePicker: "rNStandaloneFilePicker",
  subsAuth0Migration: "subsAuth0Migration",
  allowanceDetailsPanel: "allowanceDetailsPanel",
  permissionsMfaEnrollmentCohort: "permissionsMfaEnrollmentCohort",
  rFIOwnersV1: "rFIOwnersV1",
  bdsContentHeaderListPageReplacement: "bdsContentHeaderListPageReplacement",
  worksheetAGGrid: "worksheetAGGrid",
  estimateMobileServices: "estimateMobileServices",
  sageARPayments: "sageARPayments",
  sageSync: "sageSync",
  paymentMethodUI: "paymentMethodUI",
  tasksGeneralJob: "tasksGeneralJob",
  vendorCreditAndBillPaymentForAccounting:
    "vendorCreditAndBillPaymentForAccounting",
  billsFullPageConversion: "billsFullPageConversion",
  changeOrdersNewItemHeader: "changeOrdersNewItemHeader",
  bdsContentHeaderIndividualReplacements:
    "bdsContentHeaderIndividualReplacements",
  budgetCostCodeCaching: "budgetCostCodeCaching",
  bulkExport: "bulkExport",
  billPartialPayments: "billPartialPayments",
  selectionOptionsWithAI: "selectionOptionsWithAI",
  sageIntacctMVP: "sageIntacctMVP",
  taskDependencies: "taskDependencies",
  scanAllBillAttachments: "scanAllBillAttachments",
  editBillPercentage: "editBillPercentage",
  inFlightWorkflowEdits: "inFlightWorkflowEdits",
  markupCostCodeRollup: "markupCostCodeRollup",
  allowMoveBillToADifferentJob: "allowMoveBillToADifferentJob",
  billLineItemContainer: "billLineItemContainer",
  mobileOwnerInvoiceLineItems: "mobileOwnerInvoiceLineItems",
  rNAttachmentFilePicker: "rNAttachmentFilePicker",
  changeOrderGroupSubgroups: "changeOrderGroupSubgroups",
  dailyLogsModalConversion: "dailyLogsModalConversion",
  taskGantt: "taskGantt",
  bdsContentHeaderModalReplacement: "bdsContentHeaderModalReplacement",
  tasksCustomFieldSortTweaks: "tasksCustomFieldSortTweaks",
  allocateBillCostsAcrossMultipleJobs: "allocateBillCostsAcrossMultipleJobs",
  customForwardEmailAlias: "customForwardEmailAlias",
  combinedOpenBookInvoicingIteration2: "combinedOpenBookInvoicingIteration2",
  selectionsReimagined: "selectionsReimagined",
  aIASignatureWorkflow: "aIASignatureWorkflow",
  sageInvoice: "sageInvoice",
  timeClockShiftDetailsHistory: "timeClockShiftDetailsHistory",
  massEditCostGroups: "massEditCostGroups",
  progressInvoiceRevisedBudgetColumn: "progressInvoiceRevisedBudgetColumn",
  xeroReconnectAfterError: "xeroReconnectAfterError",
  financialEntityNumbering: "financialEntityNumbering",
  disableToDos: "disableToDos",
  useRemoteEmailClassification: "useRemoteEmailClassification",
  billLineItemContainerDesktop: "billLineItemContainerDesktop",
  lowesInCompanySettings: "lowesInCompanySettings",
  internalUsersMassActions: "internalUsersMassActions",
  subVendorAttachments: "subVendorAttachments",
  deferBillsPermissionCalls: "deferBillsPermissionCalls",
  trackAllowanceProgress: "trackAllowanceProgress",
  mobileInAppFeedback: "mobileInAppFeedback",
  watchingForTasks: "watchingForTasks",
  billAccountingSyncMoment: "billAccountingSyncMoment",
  defaultSubToMailedChecks: "defaultSubToMailedChecks",
  progressInvoicesAccountingIntegration:
    "progressInvoicesAccountingIntegration",
  invoiceCreationAlignment: "invoiceCreationAlignment",
  massBillPayRedesign: "massBillPayRedesign",
  requireStepUpAuthForOutboundPayments: "requireStepUpAuthForOutboundPayments",
  schedulePagedGanttPrint: "schedulePagedGanttPrint",
  selectionsAICostCodeMatching: "selectionsAICostCodeMatching",
  lienWaiverTemplateUpdates: "lienWaiverTemplateUpdates",
  progressInvoiceRetainageIndicator: "progressInvoiceRetainageIndicator",
  taxesChangeOrders: "taxesChangeOrders",
  estimateActivityLog: "estimateActivityLog",
  billPaymentScheduling: "billPaymentScheduling",
  progressInvoicesChangeOrders: "progressInvoicesChangeOrders",
  bulkRoleManagement: "bulkRoleManagement",
  apBillRetainage: "apBillRetainage",
  mobileWebviewExperience: "mobileWebviewExperience",
  jcbViewTabs: "jcbViewTabs",
  vendorCreditRelease1: "vendorCreditRelease1",
  paymentsControllerRefactor: "paymentsControllerRefactor",
  bluebeamIntegration: "bluebeamIntegration",
  enableNutrientPhotoDraw: "enableNutrientPhotoDraw",
  vendorCreditOfflinePartialPayments: "vendorCreditOfflinePartialPayments",
  syncBillPaymentsToQBD: "syncBillPaymentsToQBD",
  progressInvoicesOpenBook: "progressInvoicesOpenBook",
  combinedSubSmsNotifications: "combinedSubSmsNotifications",
  newItemHeaderDefaultJobPermissions: "newItemHeaderDefaultJobPermissions",
  costInboxMigration: "costInboxMigration",
  disableSubOwnerExternalEmails: "disableSubOwnerExternalEmails",
  timeClockBillRate: "timeClockBillRate",
  legacySelectionClientList: "legacySelectionClientList",
  wipReportSnapshotting: "wipReportSnapshotting",
  selectionsInvoicingWizard: "selectionsInvoicingWizard",
  taskPhaseDemo: "taskPhaseDemo",
  qbdWebConnectorHangfireDefer: "qbdWebConnectorHangfireDefer",
  globalSpecCatalog: "globalSpecCatalog",
  billsAgGridMigration: "billsAgGridMigration",
  taxesOnTemplates: "taxesOnTemplates",
  taxesChangeOrdersWeb: "taxesChangeOrdersWeb",
  aIPreliminaryEstimate: "aIPreliminaryEstimate",
  selectionOptionsLineItemCard: "selectionOptionsLineItemCard",
  specPublishPushNotifications: "specPublishPushNotifications",
  enableSpecPublishNotifications: "enableSpecPublishNotifications",
  specsDeprecateListView: "specsDeprecateListView",
  specsCarryForwardToBidPackage: "specsCarryForwardToBidPackage",
  linkPlansToSubmittals: "linkPlansToSubmittals",
  messagesAllowMobileVideoUploads: "messagesAllowMobileVideoUploads",
  jpsFinancialOverviewRevamp: "jpsFinancialOverviewRevamp",
  billsAccountingExport: "billsAccountingExport",
  plansNotifications: "plansNotifications",
  selectionsInvoicingWizardLineItems: "selectionsInvoicingWizardLineItems",
  taxesSelectionChoices: "taxesSelectionChoices",
  globalSpecCostGroupLinking: "globalSpecCostGroupLinking",
  dailyLogsAutoSave: "dailyLogsAutoSave",
  jpsAllowances: "jpsAllowances",
  splitBillsPOsBudgetSettings: "splitBillsPOsBudgetSettings",
  mobileDirectoryAddExperience: "mobileDirectoryAddExperience",
  newItemHeaderJobDetails: "newItemHeaderJobDetails",
  defaultSpcOn: "defaultSpcOn",
  aiPoweredSearch: "aiPoweredSearch",
  specsCarryForwardToPO: "specsCarryForwardToPO",
  aiBillProcessingV2Endpoint: "aiBillProcessingV2Endpoint",
  specsCarryForwardSelectionsToPo: "specsCarryForwardSelectionsToPo",
  warrantiesModalConversion: "warrantiesModalConversion",
  draftStatusOnBills: "draftStatusOnBills",
} as const;
